<div>
  <mic-breadcrumb id="cam-spec-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link link="/home/specifications" label="{{ translationService.translate('camSpecsText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link
      link="/home/specifications/assigncams"
      label="{{ translationService.translate('assignCamSpecsText') }}"
    ></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h3 id="cam-spec-heading">Assign CAM Spec: {{ specDesc }}</h3>

  <mat-card class="search-card mt-5">
    <div class="w-full flex flex-row items-center justify-between">
      <div class="w-full justify-self-start">
        <mat-form-field class="w-1on3" id="search-field" subscriptSizing="dynamic">
          <mat-label>Search by Customer Code or Customer Name</mat-label>
          <input type="text" matInput [formControl]="search" autocomplete="off" (keydown.enter)="onSearchClick()" />
          <button id="search-icon" (click)="onSearchClick()" mat-icon-button matSuffix>
            <mat-icon>search</mat-icon>
          </button>
          @if (searchWarning) {
          <mat-hint id="assignCustomerWarning" class="mic-info">{{ searchCustomerWarning }}</mat-hint>
          }
        </mat-form-field>
      </div>

      <div class="flex pr-5">
        <button id="cancel-button" mat-flat-button color="primary" (click)="onCancelClick()">Cancel</button>
      </div>
      <div class="flex">
        <button id="assign-button" mat-flat-button color="primary" (click)="onAssignClick()" [loading]="assignProcessing">Assign</button>
      </div>
    </div>
  </mat-card>

  <div id="customer-info-table" class="cam-table mt-2">
    <mic-table #paginatedTable class="table-stripped" [config]="tableConfig" [filtersConfig]="" [fetcher]="fetcher">
      <ng-container *micTableNoData>
        <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"> </mic-empty-state>
      </ng-container>

      <ng-container *micTableColumnSelector>
        <button id="table-column-selector" mat-flat-button class="column-button">
          <mat-icon>view_column</mat-icon>{{ translationService.translate('columnsButtonText') }}
        </button>
      </ng-container>

      <ng-container *micTableActions="let items">
        <div class="footer flex flex-row justify-center items-center">
          <div id="table-items-selected" class="mr-4">
            <span class="selection">{{ selection.length }}</span> {{ translationService.translate('itemsSelectionText') }}
          </div>

          <!-- TODO: Once we populate the table, lets use the commented logic to conditionally display export button
          @if (items?.length) {
            <button mat-flat-button color="accent"><mat-icon>file_download</mat-icon> Export</button>
          } -->
        </div>
      </ng-container>
    </mic-table>
  </div>
  <mic-modal class="modalC" #infoModal></mic-modal>

  <ng-template #confirmation><b>Enter a valid search string</b></ng-template>

  <mic-modal class="modalC" #assignModal (result)="onAssignModalClosed($event)"></mic-modal>

  <ng-template #assignContent>
    {{ assignPopupTextFirstPart }}<b>{{ specDesc }}</b
    >{{ assignPopupTextSecondPart }}<b>{{ selection.length }}</b
    >{{ assignPopupTextLastPart }}
  </ng-template>
</div>
